import axios from './axios'
import generateService from './generator'

function service(endpoint) {
    const base = generateService(endpoint);

    function deactivate(id) {
        return axios.post(`${endpoint}/${id}/deactivate`).then(response => {
            return response.data;
        }).catch(e => {
            throw e
        });
    }

    return {
        fetchList: base.fetchList,
        fetchAll: base.fetchAll,
        store: base.store,
        update: base.update,
        deactivate
    }
}

export default service
